export var OrgDeleteJobStatus;
(function (OrgDeleteJobStatus) {
    OrgDeleteJobStatus["PENDING"] = "pending";
    OrgDeleteJobStatus["IN_PROGRESS"] = "in_progress";
    OrgDeleteJobStatus["COMPLETED"] = "completed";
    OrgDeleteJobStatus["FAILED"] = "failed";
    OrgDeleteJobStatus["CANCELLED"] = "cancelled";
})(OrgDeleteJobStatus || (OrgDeleteJobStatus = {}));
//# sourceMappingURL=organisationDeleteJob.js.map